
<div
    [id]="id + '.' + filter.id"
    class="agpr-filterRadio"
>
    <agpr-scroll-panel>
        <div
            role="radiogroup"
            [attr.aria-label]="'Common.radio.radioGroupAriaLabel' | localize"
        >
            <ul>
                <li
                    *ngFor="let option of filter.options; let i = index"
                    class="agpr-filterRadio-item"
                >
                    <agpr-radio
                        [id]="id + '_' + filter.id + '_radio-' + i"
                        class="agpr-filterRadio-radio"
                        [name]="'filterRadio-' + filter.id"
                        [label]="option.label"
                        [hiddenLabel]="option.label"
                        [(ngModel)]="value"
                        [value]="option.value"
                        (onClick)="handleChange(option.value)"
                    >
                        <span
                            *ngIf="option.count || option.count === 0"
                            class="agpr-filterRadio-itemCount"
                            [pTooltip]="option.count | number"
                        >
                            {{ option.count | significantDigits : 1}}
                        </span>
                    </agpr-radio>
                </li>
            </ul>
        </div>
    </agpr-scroll-panel>
</div>
